import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Label } from '../typographies';
import { ColorAddiCompFiveBase, ColorAddiFontError, ColorAddiFontHint, ColorAddiFontPrimary, ColorAddiFontSecondary, ColorAddiFontStrong, ColorAddiGrayLighten3, } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilySecondaryName, FontAddiWeightSemiBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
export const LabelTxt = styled.span `
  position: relative;
`;
export const InputContainer = styled.div `
  width: 100%;
  height: 2.2rem;
  position: relative;
  display: flex;
  align-items: center;

  ${(props) => props.error &&
    css `
      ${InputText} {
        border-bottom-color: ${ColorAddiFontError};
      }
    `}
`;
export const DatepickerToggle = styled.span `
  display: inline-block;
  height: 19px;
  position: relative;
  vertical-align: middle;
  width: 20px;
`;
export const DatepickerToggleButton = styled.span `
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
export const DatepickerInput = styled.input `
  box-sizing: border-box;
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
    height: 100%;
    left: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
export const InputText = styled.input `
  width: 100%;
  height: 100%;
  padding: 0.5rem 0 0 0;
  border: none;
  border-bottom: solid 1px ${ColorAddiGrayLighten3};
  background: transparent;
  box-sizing: border-box;
  color: ${ColorAddiFontPrimary};
  letter-spacing: 0.02rem;
  font-size: ${SizeAddiFontSmall};
  line-height: 21px;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightSemiBold};

  &:disabled {
    color: ${ColorAddiFontSecondary};

    & + ${Label} {
      color: ${ColorAddiFontStrong};
    }
  }

  &:focus {
    outline: none;
    border-width: 1px;
    border-color: ${ColorAddiCompFiveBase};

    &::before {
      border-width: 1px;
    }
  }

  &::placeholder {
    color: ${ColorAddiFontHint};
  }
`;
export const DateIcon = styled(FontAwesomeIcon) `
  margin-right: 5px;
  font-size: 0.875rem;
  height: 16px;
  width: 13px;
`;
export const StoryDiv = styled.div `
  margin: 30px;
`;
export const InputLabel = styled(Label) `
  position: absolute;
  left: 0;
  top: -10px;
  padding: 0;
  pointer-events: none;
  letter-spacing: 0.02rem;
  line-height: 17px;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    top: 10px;
    left: 0;
    z-index: 0;
  }
`;
export const Helpers = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
`;
const Hint = styled(Label) `
  line-height: 14px;
  padding: 5px 0;
  margin: 0;
  color: ${ColorAddiFontHint};
  width: 100%;
  padding: 0;
`;
export const Error = styled(Hint) `
  color: ${ColorAddiFontError};
`;
//# sourceMappingURL=Datepicker.styled.js.map